const BASE_URL = process.env.REACT_APP_API_URL ?? '';

export const getTournaments = async (pageIndex, pageSize) => {
  const url = new URL('/api/tournaments', BASE_URL || window.location.origin);
  url.searchParams.set('page', `${pageIndex}`);
  url.searchParams.set('pageSize', `${pageSize}`);
  const response = await fetch(url.href);
  return response.json();
};

export const getTournament = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}`);
  return response.json();
};

export const getTournamentPlayers = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/players`);
  return response.json();
};

export const getTournamentRounds = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/rounds`);
  return response.json();
};

